// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\locations\\\\PlanYourVisitSection\\\\components\\\\EmailIcon.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\locations\\PlanYourVisitSection\\components\\EmailIcon.tsx");
  import.meta.hot.lastModified = "1757171103328.2522";
}
// REMIX HMR END

export function EmailIcon() {
  return <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 2.14062C2.14844 2.14062 1.875 2.45312 1.875 2.76562V3.66406L8.59375 9.17188C9.41406 9.83594 10.5469 9.83594 11.3672 9.17188L18.125 3.66406V2.76562C18.125 2.45312 17.8125 2.14062 17.5 2.14062H2.5ZM1.875 6.08594V12.7656C1.875 13.1172 2.14844 13.3906 2.5 13.3906H17.5C17.8125 13.3906 18.125 13.1172 18.125 12.7656V6.08594L12.5781 10.6172C11.0547 11.8672 8.90625 11.8672 7.42188 10.6172L1.875 6.08594ZM0 2.76562C0 1.39844 1.09375 0.265625 2.5 0.265625H17.5C18.8672 0.265625 20 1.39844 20 2.76562V12.7656C20 14.1719 18.8672 15.2656 17.5 15.2656H2.5C1.09375 15.2656 0 14.1719 0 12.7656V2.76562Z" fill="rgba(18, 18, 18, 0.4)" />
    </svg>;
}
_c = EmailIcon;
var _c;
$RefreshReg$(_c, "EmailIcon");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;